var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdministierbarLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AdministrierBar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AdministrierBar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines",
    transform: "translate(45.000000, 45.000000) rotate(-90.000000) translate(-45.000000, -45.000000) translate(13.000000, 14.000000)",
    fill: "#66BFAC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 64,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 28,
    width: 64,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,55 L60.5,55 C62.4329966,55 64,56.5670034 64,58.5 C64,60.4329966 62.4329966,62 60.5,62 L3.5,62 C1.56700338,62 2.36723813e-16,60.4329966 0,58.5 C-2.36723813e-16,56.5670034 1.56700338,55 3.5,55 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "controls",
    transform: "translate(10.000000, 26.500000)",
    stroke: "#FFFFFF",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,-2.5 L11,-2.5 C14.5898509,-2.5 17.5,0.410149126 17.5,4 L17.5,13 C17.5,16.5898509 14.5898509,19.5 11,19.5 L4,19.5 C0.410149126,19.5 -2.5,16.5898509 -2.5,13 L-2.5,4 C-2.5,0.410149126 0.410149126,-2.5 4,-2.5 Z",
    id: "Rectangle",
    fill: "#009374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,14.5 L39,14.5 C42.5898509,14.5 45.5,17.4101491 45.5,21 L45.5,30 C45.5,33.5898509 42.5898509,36.5 39,36.5 L32,36.5 C28.4101491,36.5 25.5,33.5898509 25.5,30 L25.5,21 C25.5,17.4101491 28.4101491,14.5 32,14.5 Z",
    id: "Rectangle",
    fill: "#B1C800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,3.5 L66,3.5 C69.5898509,3.5 72.5,6.41014913 72.5,10 L72.5,19 C72.5,22.5898509 69.5898509,25.5 66,25.5 L59,25.5 C55.4101491,25.5 52.5,22.5898509 52.5,19 L52.5,10 C52.5,6.41014913 55.4101491,3.5 59,3.5 Z",
    id: "Rectangle",
    fill: "#DD3C5D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministierbarLogo);
export default __webpack_public_path__ + "static/media/administierbar-logo.744d04d3133c9ba12b04d0664013f1b7.svg";
export { ForwardRef as ReactComponent };